import { ServerError, ServerParseError } from '@apollo/client';
import { NetworkError } from '@apollo/client/errors';
import { getAccessToken, loginRedirect } from './authUtils';

export const networkErrorHandler = (
  networkError:
    | Error
    | ServerError
    | ServerParseError
    | undefined
    | NetworkError,
) => {
  if (
    getAccessToken() === undefined ||
    // @ts-ignore
    (networkError && networkError.statusCode === 401)
  ) {
    redirectToLoginPage();
  }
};

export const redirectToLoginPage = () => {
  loginRedirect();
};
